<script lang="ts" setup>
const props = defineProps<{
  issue:
    | 'hasHolds'
    | 'notAvailableForPickup'
    | 'missingLicensePlate'
    | 'violatesReturnRules'
    | 'requiresCheckIn'
}>()
</script>

<template>
  <!-- icons below are tied to the IssueSelector -->
  <i-mdi:alert-circle
    v-if="props.issue === 'hasHolds'"
    data-testid="mdi-alert-circle"
  />
  <i-mdi:truck-delivery
    v-else-if="props.issue === 'notAvailableForPickup'"
    data-testid="mdi-truck-delivery"
  />
  <i-mdi:car
    v-else-if="props.issue === 'missingLicensePlate'"
    data-testid="mdi-car"
  />
  <i-mdi:alert-octagon
    v-else-if="props.issue === 'violatesReturnRules'"
    data-testid="mdi-alert-octagon"
  />
  <i-mdi:check-circle
    v-else-if="props.issue === 'requiresCheckIn'"
    data-testid="mdi-check-circle"
  />
</template>
